
<template>
  <SideMenuBase :menuGroups="menuGroups" />
</template>

<script setup>
import SideMenuBase from '@/components/layout/SideMenuBase.vue'

const menuGroups = [
  {
    title: 'Analytics',
    items: [
      { label: 'Dashboard', path: '/sales-marketing/analytics/dashboard' },
      { label: 'Memberships', path: '/sales-marketing/analytics/memberships', requiredPermission: 'sales_marketing.analytics.access_memberships' },
      { label: 'Revenue', path: '/sales-marketing/analytics/revenue', requiredPermission: 'sales_marketing.analytics.access_revenue' },
    ]
  },
  {
    title: 'CBG',
    items: [
      { label: 'Inputs', path: '/sales-marketing/cbg/inputs', requiredPermission: 'sales_marketing.cbg_inputs.access' },
      { label: 'Calculator', path: '/sales-marketing/cbg/calculator', requiredPermission: 'sales_marketing.cbg.access_calculator'},
      { label: 'Current Book', path: '/sales-marketing/cbg/current', requiredPermission: 'sales_marketing.cbg.view_current_book'},
      { label: 'Future Book', path: '/sales-marketing/cbg/future', requiredPermission: 'sales_marketing.cbg.view_future_book'}
    ]
  }
]
</script>
